import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserAuthIamService } from '../services/user-auth-iam/user-auth-iam.service';
import User from '../services/user-auth/User';
import { Redirect } from '../model/Redirect';
import { redirect } from '../../proof-of-life/env/environment';
import { PersonValidateService, IOptin } from '../services/person-validate/person-validate.service';

import { DeviceService } from '../services/device/device.service';
import { Router } from '@angular/router';

@Component({
    selector: 'dp-form-optin',
    templateUrl: './form-optin.component.html',
    styleUrls: ['./form-optin.component.scss']
})
export class FormOptinComponent implements OnInit {
    @Output() public onsuccess = new EventEmitter();
    @Output() public onerror = new EventEmitter();

    public userData = new User({});
    public readonly redirect: Redirect = redirect;
    public form: FormGroup;
    public loadingUser = false;
    public submitting = false;
    public showModal = false;
    public success = false;
    public error = false;
    public leavePage = false;
    public invalidCertificate = false;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private personService: PersonValidateService,
        private deviceService: DeviceService,
        private iamService: UserAuthIamService
    ) {}

    public ngOnInit() {
        this.loadingUser = true;
        

        this.iamService.accountData().subscribe(
            data => {
                this.userData = data;
                this.loadingUser = false;
            },
            () => {
                this.loadingUser = false;
                this.error = true;
            }
        );

        this.form = this.fb.group({
            files: this.fb.control(null, Validators.required)
        });
        this.checkOptin();
    }

    get files() {
        return this.form.get('files');
    }

    public onChangeFile(files) {
        this.files.setValue(files.images);
        this.files.markAsTouched();

        const { images } = files;
        const invalid = !images.front || !images.back || !images.selfie;

        this.files.setErrors(invalid ? { required: true } : null);
    }

    public onSubmit(event) {
        this.submitting = true;

        const { files } = this.form.value;

        const values = {
            deviceId: this.deviceService.deviceId,
            selfie: files.selfie,
            front: files.front,
            back: files.back
        };

        this.personService.optin(values).subscribe(
            () => {
                this.handleSuccess();
            },
            (error: Response) => {
                if (error.status === 504 || error.status === 0) {
                    // Pode ocorrer timeout, porém com sucesso na criação do optin
                    this.checkOptin();
                } else {
                    this.handleError(error);
                }
            }
        );
    }

    public clearModal() {
        this.showModal = false;
        this.submitting = false;
        this.success = false;
        this.error = false;
        this.leavePage = false;
    }

    public showLeavePage() {
        this.leavePage = true;
        this.showModal = true;
    }

    public confirmSuccess() {
        this.onsuccess.emit();
    }

    public confirmSuccessLandingPage(){
        this.router.navigate(['/']);
    }

    public confirmError() {
        this.onerror.emit();
    }

    public confirmLeavePage() {
        window.open('https://www.serasa.com.br/meus-dados/alterar-dados/', '_self');
    }

    private checkOptin() {
        this.personService.optinStatus().subscribe(
            (response: IOptin[]) => {
                if(response.length > 0){ 
                const openOptin = this.personService.getPendingOptin(response);
                if (openOptin) {

                    this.handleSuccess();
                } else {
                    this.handleError();
                }
            }
            },
            error => this.handleError(error)
        );
    }

    private handleSuccess() {
        this.error = false;
        this.success = true;
        this.submitting = false;
        this.showModal = true;
        this.onsuccess.emit();
    }

    private handleError(error?: Response) {
        this.success = false;
        this.error = true;
        this.submitting = false;
        this.showModal = true;
    }
}